import React, { useEffect, useState } from 'react';
import { useI18n } from '../i18n/I18nContext';
import { Overlay } from './Overlay';

export const AboutOverlay: React.FC = () => {
  const { t } = useI18n();
  const [version, setVersion] = useState<string>('...');

  useEffect(() => {
    const fetchVersion = async () => {
      try {
        // Check if running as TWA/PWA using display-mode media query
        const displayModeStandalone = window.matchMedia('(display-mode: standalone)').matches;
        const displayModeFullscreen = window.matchMedia('(display-mode: fullscreen)').matches;
        const displayModeMinimalUI = window.matchMedia('(display-mode: minimal-ui)').matches;
        const displayModeBrowser = window.matchMedia('(display-mode: browser)').matches;
        const navigatorStandalone = (window.navigator as any).standalone === true;
        
        const isStandalone = displayModeStandalone || displayModeFullscreen || navigatorStandalone;
        
        // Detailed logging for debugging TWA detection
        console.log('[AboutOverlay] TWA Detection Details:', {
          displayModeStandalone,
          displayModeFullscreen,
          displayModeMinimalUI,
          displayModeBrowser,
          navigatorStandalone,
          isStandalone,
          referrer: document.referrer,
          userAgent: navigator.userAgent,
          windowLocation: window.location.href,
          documentURL: document.URL,
          baseURI: document.baseURI
        });
        
        if (isStandalone) {
          // For TWA/Installed PWA, fetch version from server to avoid cache
          const response = await fetch('/version.json?t=' + Date.now(), {
            cache: 'no-cache',
            headers: { 'Cache-Control': 'no-cache' }
          });
          const data = await response.json();
          setVersion(data.version + ' (App)');
        } else {
          // For browser PWA, fetch version.json
          const response = await fetch('/version.json?t=' + Date.now());
          const data = await response.json();
          setVersion(data.version + ' (Web)');
        }
      } catch (error) {
        console.error('Failed to fetch version:', error);
        setVersion('ERROR (Check console)');
      }
    };

    fetchVersion();
  }, []);

  return (
    <Overlay
      title={t('about.title')}
      className="about-overlay"
      zIndex={2000}
      alignItems="center"
    >
      <div className="about-content">
        <div className="about-section">
          <h3>{t('about.versionInfo')}</h3>
          <p>{version}</p>
        </div>

        <div className="about-section">
          <h3>{t('about.forecastSystem')}</h3>
          <p>{t('about.forecastCredit')}</p>
        </div>

        <div className="about-section">
          <h3>{t('about.mapViewer')}</h3>
          <p>{t('about.mapCredit')}</p>
        </div>
      </div>
    </Overlay>
  );
};
